import { Box, Checkbox, Typography } from "@mui/material";
import { NormalTable } from "../../../components/TableCustomize";
import STAFF_STOCK_TABLE_COLUMN_PROPERTIES from "./const/StaffStockTableColumnProperties";

export default function StaffStockTable({staffStockInfoList, pagination, movePage, searchedCondition, selectedStocks}) {

  const selectedProperty = {
    key: "selected",
    label: () => (
      <Box>
        <Typography>選択</Typography>
        <Checkbox
          checked={selectedStocks.isSelectedAll(staffStockInfoList)}
          onChange={(e) => {
            e.target.checked
              ? selectedStocks.selectAllStocks(staffStockInfoList)
              : selectedStocks.clear()
          }}
        />
      </Box>
    ),
    align: "center",
    // isGroup: true,
    dataKey: "selected",
    cellProps: {
      width: "35mm",
      rowCell: {
        borderRight: "1px solid #e0e0e0",
      },
    },
    render: (item) => (
      <Checkbox
        checked={item.selected}
        onChange={(e) => {item.changeSelected(e.target.checked)}}
      />
    )
  }

  const displayStaffStockInfoList
    = staffStockInfoList
      .slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize)
      .map((staffStockInfo, index) => ({
        ...staffStockInfo,
        key: "stackStockInfo_" + index.toString(),
        displayPurchasePrice : staffStockInfo.purchasePrice.toLocaleString(),
        displayStockAmount : staffStockInfo.stockAmount.toLocaleString(),
        displayTotalPurchasePrice :staffStockInfo.totalPurchasePrice.toLocaleString(),
        selected: Boolean(selectedStocks.findStock(staffStockInfo.salesRecordNo, staffStockInfo.salesDetailId)),
        changeSelected: (selected) => selectedStocks.setStockSelected(staffStockInfo.salesRecordNo, staffStockInfo.salesDetailId, staffStockInfo.isAvailableStock, selected)
      }));

  return (
    <NormalTable
      columns={[
        selectedProperty,
        ...STAFF_STOCK_TABLE_COLUMN_PROPERTIES
      ]}
      data={displayStaffStockInfoList || []}
      pagination={{
        ...pagination,
        handleChangePageProps: async (page) => {movePage(page)},
      }}
      paginationTop
    searchedCondition = {searchedCondition}
    />
  );
}
